import newPhase from "./newPhase.ts";

export default {
	newPhase,
};
